export enum ValidationErrors {
  address_not_found = 'address_not_found',
  address_not_serviceable = 'address_not_serviceable',
  no_drivers_available = 'no_drivers_available',
  no_couriers_available = 'no_couriers_available',
}
